import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import { useAppServices } from 'hook/services'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

export default function DataTableData() {
  const AppService = useAppServices()
  const [List, setList] = useState([])
  const [exportloading, setexportloading] = useState(false)
  const [loader, setLoader] = useState(true)
  const navigate = useNavigate()
  const [pagination, setPagination] = useState({
    total: 0,
    page: 1,
    limit: 50,
    totalPages: 0,
  })

  // In your DataTableData.js file, update the getGhlLocations function:
  const getGhlLocations = async (page = 1, limit = pagination.limit, search = '') => {
    setLoader(true)

    const query = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    })

    if (search) {
      query.append('search', search)
    }

    const { response, error } = await AppService.agency.GetGhlLocations({
      query: query.toString(),
    })

    if (response && response.success) {
      setList(response.data)
      setPagination({
        total: response?.pagination?.total,
        page: response.pagination.page,
        limit: response.pagination.limit,
        totalPages: response.pagination.totalPages,
      })
    } else {
      setList([])
      console.error('Error fetching data:', error)
    }

    setLoader(false)
  }

  const onLoad = () => {
    getGhlLocations(pagination.page, pagination.limit)
  }

  const handlePageChange = (newPage) => {
    getGhlLocations(newPage, pagination.limit)
  }

  const handleLimitChange = (newLimit) => {
    setPagination((prev) => ({ ...prev, page: 1, limit: newLimit }))
    getGhlLocations(1, newLimit)
  }

  const handleStatusChange = async (id) => {
    const payload = { id, access: false }
    const { response } = await AppService.agency.RemoveAccess({ payload })
    if (response) onLoad()
  }

  const handleGrantAccess = async (id) => {
    const payload = { id, access: true }
    const { response } = await AppService.AccessRequest.RegrantFromAgency({
      payload,
    })
    if (response) onLoad()
  }

  useEffect(onLoad, [])

  const handleDownloadCSV = async () => {
    try {
      console.log('Starting CSV download...')
      setexportloading(true)
      const { response } = await AppService.agency.ExportGhlLocationsCSV()
      console.log('API Response:', response)

      if (response && response.success && response.data && response.data.csv) {
        console.log('CSV data received, length:', response.data.csv.length)

        // Create blob with proper encoding
        const blob = new Blob([response.data.csv], {
          type: 'text/csv;charset=utf-8;',
        })

        console.log('Blob created, size:', blob.size)

        // Create download link
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')

        link.href = url
        link.download = 'Installation users.csv'
        link.style.display = 'none'

        // Add to DOM, click, and cleanup
        document.body.appendChild(link)
        link.click()

        // Small delay before cleanup to ensure download starts
        setTimeout(() => {
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
        }, 100)
        setexportloading(false)

        console.log('Download initiated')
      } else {
        console.error('Failed to generate CSV - invalid response:', response)
        alert('Failed to generate CSV. Please check console for details.')
      }
    } catch (error) {
      console.error('CSV download error:', error)
      alert('Error downloading CSV: ' + error.message)
    }
  }

  return {
    loader,
    handleRefresh: onLoad,
    pagination,
    exportloading,
    handlePageChange,
    getGhlLocations,
    handleDownloadCSV,
    handleLimitChange,
    dataTableData: {
      columns: [
        { Header: 'First Name', accessor: 'firstName' },
        { Header: 'Last Name', accessor: 'lastName' },
        { Header: 'Location Name', accessor: 'loc_name' },
        { Header: 'Location Id', accessor: 'id' },
        { Header: 'Email', accessor: 'email' },
        { Header: 'License Key', accessor: 'license_key' },
        { Header: 'Access', accessor: 'access' },
        { Header: 'Domain', accessor: 'domain' },
        { Header: 'Address', accessor: 'address' },
        { Header: 'Phone', accessor: 'phone' },
        { Header: 'Listings', accessor: 'accounts' },
        { Header: 'First Login', accessor: 'createdAt' },
        { Header: 'Most Recent Login', accessor: 'updatedAt' },
        { Header: 'Action', accessor: 'action' },
      ],

      rows: List.map((data) => ({
        firstName: data.firstName,
        lastName: data.lastName,
        loc_name: data?.loc_name || 'N/A',
        id: data?.id,
        email: data.email,
        license_key: data.license_key,
        access:
          data?.agency?.access && data?.agency?.access === true ? 'Accessed' : 'Access Removed',
        domain: data?.agency?.domain || 'N/A',
        address: data.address,
        phone: data.phone,
        accounts: data.accounts,
        createdAt: new Date(data?.agency?.createdAt).toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
        }),
        updatedAt: new Date(data?.agency?.updatedAt).toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
        }),
        action: (
          <MDBox>
            <MDButton
              variant="contained"
              color="primary"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => navigate(`./DetailPage/${data.license_key}`)}
            >
              View
            </MDButton>
            {data?.agency && 'access' in data.agency ? (
              data.agency.access ? (
                <MDButton
                  variant="contained"
                  color="error"
                  size="small"
                  sx={{ marginLeft: 2 }}
                  onClick={() => handleStatusChange(data.id)}
                >
                  Remove Access
                </MDButton>
              ) : (
                <button
                  type="button"
                  onClick={() => handleGrantAccess(data.id)}
                  style={{
                    backgroundColor: 'black',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    padding: '6px 16px',
                    fontSize: '14px',
                    cursor: 'pointer',
                    transition: 'background-color 0.3s ease',
                    marginLeft: 16,
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = 'darkblue')}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'blue')}
                >
                  Restore Access
                </button>
              )
            ) : (
              <MDButton
                variant="contained"
                color="error"
                size="small"
                sx={{ marginLeft: 2 }}
                onClick={() => handleStatusChange(data.id)}
              >
                Remove Access
              </MDButton>
            )}
          </MDBox>
        ),
      })),
    },
  }
}
